import {
    Component, ViewChild, ViewContainerRef, Injector, NgModuleRef,
    ComponentFactoryResolver, ComponentRef, Input, OnChanges, SimpleChanges, OnInit, OnDestroy
} from '@angular/core';
import { Dashboard } from '../models/Dashboard';
import { Surface } from '../models/Surface';
import { DashboardsLayoutService } from '../services/dashboards.layout.service';
import * as _ from 'lodash';

@Component({
    selector: 'app-dashboard',
    template: `<ng-template #dashboardSurface>
  <!-- Layout surface gets inserted here -->
</ng-template>
`,
    styles: [``]
})
export class DashboardsComponent implements OnInit, OnDestroy, OnChanges {
    @ViewChild('dashboardSurface', { read: ViewContainerRef }) containerElement: ViewContainerRef;

    // public dashboard model property
    @Input() model: Dashboard;

    private surfaceContainerRef: ComponentRef<Surface>;

    constructor (
        private injector: Injector,
        private moduleRef: NgModuleRef<any>,
        private dashboardsLayoutService: DashboardsLayoutService,
        private componentFactoryResolver: ComponentFactoryResolver) {
    }

    ngOnChanges(changes: SimpleChanges) {
        // only the 'model' property would fire this event handler
        // so when the 'model' object changes shallowly, we:

        console.log('dashboard model changes');

        this.destroySurface();

        // IF MODEL HAS CHANGED, UPDATE SURFACE MODEL HERE

        this.createSurface();
    }

    ngOnInit() {
    }

    ngOnDestroy() {
        this.destroySurface();
    }

    createSurface() {
        if (!this.model) {
            return;
        }

        // create a container component factory
        const surfaceComponent = this.dashboardsLayoutService.getSurfaceComponent(this.model.layout);
        if (!surfaceComponent) {
            throw new Error(`Cannot find surface component for layout ${this.model.layout}.`);
        }

        const containerFactory = this.componentFactoryResolver.resolveComponentFactory(surfaceComponent);

        // create the container component
        const containerRef: ComponentRef<Surface> = containerFactory.create(this.injector, [], null, this.moduleRef);

        // set surface container 'model' properties
        containerRef.instance.model = this.model;

        // keep a reference to the component so we can destroy it
        this.surfaceContainerRef = containerRef;

        // insert the container into the ViewContainerRef
        this.containerElement.insert(containerRef.hostView);
    }

    private destroySurface() {
        if (this.surfaceContainerRef) {
            this.surfaceContainerRef.destroy();
            this.surfaceContainerRef = null;
        }
    }
}
